<style>

</style>
<template>
<div id="education">
   <body>

 <h3><font size="5">Education</font></h3>
    <p> <strong>
      Florida Polytechnic University
      </strong>
    <br> Bachelor's Degree, Computer Science (2016 - 2020) <br>
    <br> <strong>Relevant Courses</strong>
        <br> • Data Structures • Database 1
        <br> • Algorithm Design and Analysis • Computer Programming 1 and 2
        <br> • Human Computer Interaction • Operating Systems Concepts
        <br> • Software Engineering • Web Application Development
</p>

</body>
</div>
</template>

<script>
   export default{

   }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
    background: #767f6c;
    padding: 30px;
}
p{
    color: black;
    font-size: 20px;

}
</style>